import { render, staticRenderFns } from "./QrCodeColors.vue?vue&type=template&id=c3118002&"
import script from "./QrCodeColors.vue?vue&type=script&lang=js&"
export * from "./QrCodeColors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports